import React from "react";

const PanelRightContent = ({...props}) => {
  return <div className="right_content main_box">{props.children}</div>;
};

export default PanelRightContent;

